import React from 'react';
import styled from '@emotion/styled';

const variants = {
  h1: {
    fontSize: '2rem',
    fontWeight: 'bold',
    color: 'red',
  },
  h2: {
    fontSize: '1.8rem',
    fontWeight: 'bold',
    color: 'blue',
  },
  h3: {
    fontSize: '1.6rem',
    fontWeight: 'bold',
    color: 'green',
  },
  default: {
    fontSize: '1.4px',
    color: 'black',
    fontFamily: 'Noto Sans',
    lineHeight: '20px'
  },
};

type CustomTextProps = {
  variant?: keyof typeof variants;
  fontFamily?: string;
  fontSize?: string;
  fontStyle?: string;
  fontWeight?: string | number;
  color?: string;
  lineHeight?: string;
  letterSpacing?: string;
  textAlign?: string;
  textDecoration?: string;
  textTransform?: string;
  children: React.ReactNode;
};



const CustomText = styled.div((props: CustomTextProps) => {
  const {
    fontFamily,
    fontSize,
    fontStyle,
    fontWeight,
    color,
    lineHeight,
    letterSpacing,
    textDecoration,
  } = props
  return ({
    ...variants[props.variant || 'default'],
    fontFamily,
    fontSize,
    fontStyle,
    fontWeight,
    color,
    lineHeight,
    letterSpacing,
    textDecoration,
  })
})

export default CustomText